import {
  Component,
  Input,
  OnInit,
  ViewChildren,
  ElementRef,
  QueryList,
} from "@angular/core";
import * as _ from "lodash";

import { ApirequestService } from "../../../shared/services/apirequest.service";
import { ApirequestdetailService } from "../../../shared/services/apirequestdetail.service";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-behavior-filters",
  templateUrl: "./behavior-filters.component.html",
  styleUrls: ["../../measures/measures.component.scss"],
})
export class BehaviorFiltersComponent implements OnInit {
  @Input() pagefilters: any;
  @Input() isOnSidebar: boolean = true;
  @ViewChildren("chkboxes") chkboxes: QueryList<ElementRef>;

  domainsFiltersList = [];
  behaviorsFiltersList = [];
  languagesFiltersList = [];
  populationFiltersList = [];
  measurementModeFiltersList = [
    { name: "Observational" },
    { name: "Physiological" },
    { name: "Self-report" },
    { name: "Task" },
    { name: "Other" },
    { name: "Not specified" },
  ];
  durationFiltersList = [
    { name: "0-5 minutes" },
    { name: "6-10 minutes" },
    { name: "11-15 minutes" },
    { name: "16-20 minutes" },
    { name: "20+ minutes" },
    { name: "Not specified" },
  ];
  sourceFiltersList = [
    { name: "Science of Behavior Change (SOBC)", key: "sobc" },
    { name: "Group Evaluated Measures (GEM)", key: "gem" },
    { name: "Stress Measurement Network (SMN)", key: "smn" },
    { name: "Emotional Well-Being (EWB)", key: "ewb" },
    { name: "Roybal", key: "roybal" },
    { id: "dyad", name: "Dyadic working group", key: "dyad" },
    { name: "User upload", key: "user_upload" },
    { name: "Other", key: "other" },
  ];
  specialLinksFiltersList = [
    { id: "bct", name: "Behavior change techniques", key: "bct" },
    { id: "ef", name: "Experiment Factory", key: "ef" },
    { id: "ca", name: "Cognitive Atlas", key: "ca" },
  ];
  domainsFilters = [];
  behaviorsFilters = [];
  languageFilters = [];
  populationFilters = [];
  measurementModeFilters = [];
  durationFilters = [];
  validityStudiesUploaded = [];
  behaviorSourceFilters = [];
  databaseFilters = [];
  specificLinksFilters = [];
  thefilter;
  btnclicked = false;
  url_behaviourfilters = "behaviours/domains_list/";
  behavior_url_behaviourfilters = "behaviours/behaviors_list/";
  language_url_behaviourfilters = "behaviours/languages_list/";
  population_url_behaviourfilters = "behaviours/population_list/";
  isType = false;
  isHypothesizedDomain = false;
  isStage = false;
  isAdvanced = false;
  isDuration = true;
  isTargetPopulation = true;
  isSource = false;
  showSource = false;
  showSpecificLinks = false;
  showType = false;
  showStage = false;
  showDuration = false;
  showTargetPopulation = false;
  behaviour_of_the_day = [];

  selectedType = "behaviors";
  itemCountKey = "behaviors";
  showBehaviors = true;
  showDomains = false;
  showLanguages = false;
  showPopulation = false;
  showMeasurementMode = false;
  showValidityStudiesUploaded = false;
  behaviorNumbers: any;
  itemCounts: any;
  filterSize = 8;
  menuItems = [
    {
      label: "Behavior Type",
      tooltip:
        "Behaviors that the researcher or implementer ultimately wishes to change, perhaps by influencing a mechanism or process",
      stateKey: "showBehaviors",
      filterList: "behaviorsFiltersList",
      type: "behaviors",
      clickHandler: () => this.toggleMenu("showBehaviors", "behaviors", ""),
    },
    {
      label: "Specific Population",
      tooltip:
        "Behaviors that are designed to be used with a specific group of people",
      stateKey: "showPopulation",
      clickHandler: () =>
        this.toggleMenu("showPopulation", "target_population", ""),
      filterList: "populationFiltersList",
      type: "target_population",
    },
    {
      label: "Measurement Mode",
      tooltip: "The behavior's mode of administration",
      stateKey: "showMeasurementMode",
      clickHandler: () =>
        this.toggleMenu(
          "showMeasurementMode",
          "measurement_mode",
          "measurement_modes"
        ),
      filterList: "measurementModeFiltersList",
      type: "measurement_mode",
    },
    {
      label: "Language",
      tooltip: "The behavior's language of administration",
      stateKey: "showLanguages",
      clickHandler: () =>
        this.toggleMenu("showLanguages", "language", "languages"),
      filterList: "languagesFiltersList",
      type: "language",
    },
    {
      label: "Duration",
      tooltip:
        "How long, on average, the behavior takes for participants to complete in the measure's target population",
      stateKey: "showDuration",
      clickHandler: () =>
        this.toggleMenu("showDuration", "duration", "durations"),
      filterList: "durationFiltersList",
      type: "duration",
    },
    // {
    //   label: "Data Source",
    //   tooltip: "How the measure was added to our repository",
    //   stateKey: "showSource",
    //   clickHandler: () => this.toggleMenu("showSource", "behavior_source", ""),
    //   filterList: "sourceFiltersList",
    //   type: "measure_source",
    // },
    // {
    //   label: "Integrations",
    //   tooltip: "Specific links that the behavior has",
    //   stateKey: "showSpecificLinks",
    //   clickHandler: () =>
    //     this.toggleMenu("showSpecificLinks", "specific_links", ""),
    //   filterList: "specialLinksFiltersList",
    //   type: "specific_links",
    // },
  ];

  constructor(
    private apirequestService: ApirequestService,
    private apirequestdetailService: ApirequestdetailService
  ) {}

  activeDropdown: string | null = null;
  isMobile = false;

  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile.bind(this));
    const url_ = "behaviours/behaviour-of-the-day/";
    var params = new HttpParams();
    this.apirequestService.get(url_, params).subscribe(
      (res) => {
        this.behaviour_of_the_day = res.results;
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.url_behaviourfilters).subscribe(
      (res) => {
        this.domainsFiltersList = res.results;
        _.each(this.domainsFiltersList, (value) => {
          if (this.pagefilters.domains.includes(value.id)) {
            this.domainsFilters.push(value.id);
          }
        });
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get("behaviours/behaviour-numbers/").subscribe(
      (res) => {
        this.behaviorNumbers = res.behaviour_source;
        this.itemCounts = res;
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.behavior_url_behaviourfilters).subscribe(
      (res) => {
        this.behaviorsFiltersList = res.results.reverse();
        _.each(this.behaviorsFiltersList, (value) => {
          if (this.pagefilters.behaviors.includes(value.id)) {
            this.behaviorsFilters.push(value.id);
          }
        });
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.language_url_behaviourfilters).subscribe(
      (res) => {
        this.languagesFiltersList = res.results;
        _.each(this.languagesFiltersList, (value) => {
          if (this.pagefilters.language.includes(value.name)) {
            this.languageFilters.push(value.name);
          }
        });
      },
      (error) => {
        console.log(error);
      }
    );

    this.apirequestService.get(this.population_url_behaviourfilters).subscribe(
      (res) => {
        this.populationFiltersList = res.results;
        _.each(this.populationFiltersList, (value) => {
          if (this.pagefilters.target_population.includes(value.name)) {
            this.populationFilters.push(value.name);
          }
        });
      },
      (error) => {
        console.log(error);
      }
    );

    _.each(
      [
        "Self-report",
        "Task",
        "Observational",
        "Physiological",
        "Other",
        "Not specified",
      ],
      (value) => {
        if (this.pagefilters.measurement_mode.includes(value)) {
          this.measurementModeFilters.push(value);
          this.showType = true;
        }
      }
    );

    _.each(
      [
        "Science of Behavior Change (SOBC)",
        "Group Evaluated Measures (GEM)",
        "Stress Measurement Network (SMN)",
        "User upload",
        "Other",
      ],
      (value) => {
        if (this.pagefilters.measure_source.includes(value)) {
          this.behaviorSourceFilters.push(value);
          this.showSource = true;
        }
      }
    );
    _.each(["None", "Influence", "Behavior change validation"], (value) => {
      if (this.pagefilters.validity_studies_uploaded.includes(value)) {
        this.validityStudiesUploaded.push(value);
        this.showStage = true;
      }
    });
    _.each(
      [
        "0-5 minutes",
        "6-10 minutes",
        "11-15 minutes",
        "16-20 minutes",
        "20+ minutes",
        "Not specified",
      ],
      (value) => {
        if (this.pagefilters.duration.includes(value)) {
          this.durationFilters.push(value);
          this.showDuration = true;
        }
      }
    );

    _.each(
      ["Behavior change techniques", "Experiment Factory", "Cognitive Atlas"],
      (value) => {
        if (this.pagefilters.specific_links.includes(value)) {
          this.specificLinksFilters.push(value);
          this.showSpecificLinks = true;
        }
      }
    );
  }

  // _.remove(v, function(n){ return n!=8;});
  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }

  toggleEditable(event, type, val) {
    console.log(event, type, val);
    if (type === "domains") {
      if (event.target.checked === true) {
        if (val == "All") {
          this.domainsFiltersList.forEach((item) =>
            this.domainsFilters.push(item.id)
          );
        } else {
          this.domainsFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.domainsFilters = [];
        } else {
          this.domainsFilters = this.arrayRemove(this.domainsFilters, val);
        }
      }
    } else if (type === "behaviors") {
      if (event.target.checked === true) {
        if (val == "All") {
          this.behaviorsFiltersList.forEach((item) =>
            this.behaviorsFilters.push(item.id)
          );
        } else {
          this.behaviorsFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.behaviorsFilters = [];
        } else {
          this.behaviorsFilters = this.arrayRemove(this.behaviorsFilters, val);
        }
      }
    } else if (type === "language") {
      if (event.target.checked === true) {
        if (val == "All") {
          this.languagesFiltersList.forEach((item) =>
            this.languageFilters.push(item.name)
          );
        } else {
          this.languageFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.languageFilters = [];
        } else {
          this.languageFilters = this.arrayRemove(this.languageFilters, val);
        }
      }
    } else if (type === "target_population") {
      if (event.target.checked === true) {
        if (val == "All") {
          this.populationFiltersList.forEach((item) =>
            this.populationFilters.push(item.name)
          );
        } else {
          this.populationFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.populationFilters = [];
        } else {
          this.populationFilters = this.arrayRemove(
            this.populationFilters,
            val
          );
        }
      }
    } else if (type === "measurement_mode") {
      if (event.target.checked === true) {
        if (val == "All") {
          this.measurementModeFiltersList.forEach((item) =>
            this.measurementModeFilters.push(item.name)
          );
        } else {
          this.measurementModeFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.measurementModeFilters = [];
        } else {
          this.measurementModeFilters = this.arrayRemove(
            this.measurementModeFilters,
            val
          );
        }
      }
    } else if (type === "duration") {
      console.log("TEST");
      if (event.target.checked === true) {
        if (val == "All") {
          this.durationFiltersList.forEach((item) =>
            this.durationFilters.push(item.name)
          );
        } else {
          this.durationFilters.push(val);
        }
      } else if (event.target.checked === false) {
        if (val == "All") {
          this.durationFilters = [];
        } else {
          this.durationFilters = this.arrayRemove(this.durationFilters, val);
        }
      }
    } else if (type === "validity_studies_uploaded") {
      if (event.target.checked === true) {
        this.validityStudiesUploaded.push(val);
      } else if (event.target.checked === false) {
        this.validityStudiesUploaded = this.arrayRemove(
          this.validityStudiesUploaded,
          val
        );
      }
    } else if (type === "behavior_source") {
      if (event.target.checked === true) {
        this.behaviorSourceFilters.push(val);
      } else if (event.target.checked === false) {
        this.behaviorSourceFilters = this.arrayRemove(
          this.behaviorSourceFilters,
          val
        );
      }
    } else if (type === "specific_links") {
      if (event.target.checked === true) {
        this.specificLinksFilters.push(val);
      } else if (event.target.checked === false) {
        this.specificLinksFilters = this.arrayRemove(
          this.specificLinksFilters,
          val
        );
      }
    }

    this.thefilter = {
      domains: this.domainsFilters.join(",") || "All",
      behaviors: this.behaviorsFilters.join(",") || "All",
      language: this.languageFilters.join(",") || "All",
      target_population: this.populationFilters.join(",") || "All",
      measurement_mode: this.measurementModeFilters.join(",") || "All",
      duration: this.durationFilters.join(",") || "All",
      measure_source: this.behaviorSourceFilters.join(",") || "All",
      validity_studies_uploaded:
        this.validityStudiesUploaded.join(",") || "All",
      database: this.databaseFilters.join(",") || "All",
      specific_links: this.specificLinksFilters.join(",") || "All",
    };
    this.apirequestdetailService.setFilteredData(this.thefilter);
  }

  toggleBehavior(show: boolean): void {
    this.showBehaviors = !show;
  }

  toggleLanguage(show: boolean): void {
    this.showLanguages = !show;
  }

  togglePopulation(show: boolean): void {
    this.showPopulation = !show;
  }

  toggleMeasurementMode(show: boolean): void {
    this.showMeasurementMode = !show;
  }

  toggleValidityStudiesUploaded(show: boolean): void {
    this.showValidityStudiesUploaded = !show;
  }

  toggleDuration(show: boolean): void {
    this.showDuration = !show;
  }

  toggleSource(show: boolean): void {
    this.showSource = !show;
  }

  toggleSpecificLinks(showSpecificLinks: boolean): void {
    this.showSpecificLinks = !showSpecificLinks;
  }

  uncheckAllFilters(): void {
    this.chkboxes.forEach((x) => (x.nativeElement.checked = false));
    this.menuItems.forEach((item) => {
      this.thefilter[item.type] = "All";
    });

    this.apirequestdetailService.setFilteredData(this.thefilter);
  }

  shouldShowFilters(): boolean {
    return this.menuItems.some((item) => this[item.stateKey]);
  }
  getCurrentFiltersList() {
    const activeItem = this.menuItems.find((item) => this[item.stateKey]);
    return activeItem ? this[activeItem.filterList] : [];
  }

  toggleMenu(selectedMenu: string, type: string, count: string) {
    this.menuItems.forEach((item) => {
      this[item.stateKey] = false;
    });
    this.selectedType = type;
    if (count == "") {
      count = type;
    }
    this.itemCountKey = count;
    this[selectedMenu] = !this[selectedMenu];

    this.activeDropdown =
      this.activeDropdown === selectedMenu ? null : selectedMenu;
  }

  getFirstHalfFilters() {
    const filtersList = this.getCurrentFiltersList();
    return filtersList.slice(0, this.filterSize);
  }

  getSecondHalfFilters() {
    const filtersList = this.getCurrentFiltersList();
    return filtersList.slice(this.filterSize, this.filterSize * 2);
  }

  getThirdHalfFilters() {
    const filtersList = this.getCurrentFiltersList();
    return filtersList.slice(this.filterSize * 2, this.filterSize * 3);
  }

  isActive(stateKey: string): boolean {
    return this[stateKey];
  }

  selectedTypeClass(): string {
    return [
      "domains",
      "target_population",
      "measurement_mode",
      "duration",
      "specific_links",
      "behavior_source",
    ].includes(this.selectedType)
      ? "col-md-6"
      : "col-md-4";
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 868; // Adjust breakpoint as needed
  }
}
